export type Hint = {
  title: string
  content: string
  link?: string
}

export type Question = {
  id: number
  question: string
  category: string
  hint: string
  options: Option[]
  selectedOptionId?: number
}

export type Option = {
  id: number
  text: string
}

export enum STEPS {
  START = 'START',
  QUESTION = 'QUESTION',
  SUCCESS = 'SUCCESS',
  FAIL = 'FAIL',
}

export enum QUESTIONNAIRE_ACTIONS {
  SET_CURRENT_STEP = 'QUESTIONNAIRE_ACTIONS.SET_CURRENT_STEP',
  SET_QUESTIONS = 'QUESTIONNAIRE_ACTIONS.SET_QUESTIONS',
  SELECT_OPTION = 'QUESTIONNAIRE_ACTIONS.SELECT_OPTION',
  NEXT_QUESTION = 'QUESTIONNAIRE_ACTIONS.NEXT_QUESTION',
  PREVIOUS_QUESTION = 'QUESTIONNAIRE_ACTIONS.PREVIOUS_QUESTION',
  SET_IS_SUBMITTING = 'QUESTIONNAIRE_ACTIONS.SET_IS_SUBMITTING',
  CLEAR_QUESTIONS = 'QUESTIONNAIRE_ACTIONS.CLEAR_QUESTIONS',
}

type SetCurrentStep = {
  type: typeof QUESTIONNAIRE_ACTIONS.SET_CURRENT_STEP
  currentStep: STEPS | null
}

type SetQuestions = {
  type: typeof QUESTIONNAIRE_ACTIONS.SET_QUESTIONS
  assessmentId: number
  questions: Question[]
}

type SelectOption = {
  type: typeof QUESTIONNAIRE_ACTIONS.SELECT_OPTION
  payload: {
    questionId: number
    optionId: number
  }
}

type NextQuestion = {
  type: typeof QUESTIONNAIRE_ACTIONS.NEXT_QUESTION
}

type PreviousQuestion = {
  type: typeof QUESTIONNAIRE_ACTIONS.PREVIOUS_QUESTION
}

type SetIsSubmitting = {
  type: typeof QUESTIONNAIRE_ACTIONS.SET_IS_SUBMITTING
  isSubmitting: boolean
}

type ClearQuestions = {
  type: typeof QUESTIONNAIRE_ACTIONS.CLEAR_QUESTIONS
}

export type ActionTypes =
  | SetQuestions
  | SelectOption
  | NextQuestion
  | PreviousQuestion
  | SetCurrentStep
  | SetIsSubmitting
  | ClearQuestions
